import React from 'react';
import UpcommingGameList from '../upcomminggames/UpcommingGameList'
import Footer from '../footer/Footer';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import { Divider, Tab} from 'semantic-ui-react'
import { currentMonth  } from '../helpers/DateUtils.jsx'
class Events extends React.Component {

 componentDidMount(){
    ReactGA.ga('send', 'pageview', '/games');
 }

 renderPanes = () => {
  let currentYear = new Date().getFullYear();
  
  const panes = [
    { menuItem: 'Games This Month: '+currentMonth(), render: () => <Tab.Pane>{this.renderCurrentMonthGames()}</Tab.Pane> },   
    { menuItem: 'Games This Year: '+currentYear, render: () => <Tab.Pane>{this.renderCurrentYearGames()}</Tab.Pane> },
    { menuItem: 'All Games', render: () => <Tab.Pane>{this.renderAllGames()}</Tab.Pane> },
  ]
  return <Tab menu={{ pointing: true }} panes={panes} />;
} 

  renderAllGames = () => {
    return (<UpcommingGameList view='all'/>)
  }

  renderCurrentYearGames = () => {
    return (<UpcommingGameList view='year'/>)
  }

  renderCurrentMonthGames = () => {
    return (<UpcommingGameList view='month'/>)
  }


  render () {
    return (
      <React.Fragment>
        <div className="ui container">
        <br/>
              <h2 className="ui header">Upcoming Games</h2>
            <h4 className="ui header">Click Game date for further information</h4>
            <Divider hidden />
              {this.renderPanes()}
            <Divider hidden />
            <Link to ="/" style={{color:'black'}} >
            <button className="ui button positive" >
              Return
            </button>
          </Link>
        </div>
        <Footer/>
      </React.Fragment>
  
    )
    }
}

export default Events;
